import classNames from 'classnames';
import type { BaseItem, AutocompleteSource } from '@algolia/autocomplete-core';

interface AutoCompleteListProps {
  autoComplete: {
    getItemProps: (args: { item: BaseItem; source: any }) => any;
    getListProps: () => any;
  };
  items: BaseItem[];
  noQuery: boolean;
  source: AutocompleteSource<BaseItem>;
}

const AutoCompleteList = ({
  items,
  noQuery,
  autoComplete,
  source: { sourceId },
  source,
}: AutoCompleteListProps) => (
  <ul {...autoComplete.getListProps()}>
    {items.map((item) => {
      return (
        <li
          className={classNames(
            'ac-autocomplete__suggestion ch-hand ch-display--flex ch-align-items--center ch-rounded--md ch-fs--2 sm:ch-fs--3 ch-fw--500 ch-ph--1 sm:ch-ph--3',
            {
              'ac-autocomplete__recent-query': sourceId === 'Recent searches',
              'ac-autocomplete__trending':
                sourceId === 'Trending searches' && noQuery,
              'ac-autocomplete__suggested-pages':
                sourceId === 'Suggested pages',
            }
          )}
          data-gtm-track="click_cta"
          data-gtm-track-label={`Instant search - ${sourceId} - ${item.query}`}
          key={item.objectID}
          {...autoComplete.getItemProps({ item, source })}
        >
          {item.query}
        </li>
      );
    })}
  </ul>
);

export default AutoCompleteList;
